export default __webpack_public_path__ + "1cd23fb643a0b43e25531d702f338bcd.png";